export default __webpack_public_path__ + "static/media/venkuKrepelkan.45d44e78.jpg";